export enum LangEnum {
    EN = 'en',
    RU = 'ru',
    ES = 'es',
    PT = 'pt',
    DE = 'de',
    FR = 'fr',
    AR = 'ar',
    ZH_CN = 'zh-CN',
    ZH_HANT = 'zh-Hant',
}
